import { render, staticRenderFns } from "./queryPage.vue?vue&type=template&id=350fb24c&scoped=true"
import script from "./queryPage.vue?vue&type=script&lang=js"
export * from "./queryPage.vue?vue&type=script&lang=js"
import style0 from "./queryPage.vue?vue&type=style&index=0&id=350fb24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350fb24c",
  null
  
)

export default component.exports